<template>
  <div class="page">
    <div class="header-section">
      <div class="head-context">
        <div>
          <p class="weight">Yanqiu Feng</p>
          <p>
            <span class="weight">Titile/Position:</span> Master student
          </p>
        </div>
        <div>
          <div class="weight">Affiliation:</div>
          <div>
            Institute of Reproductive and Child Health, School of Public
            Health,<br />
            Peking University, Beijing 100191, P.R. China
          </div>
        </div>
        <div>
          <span class="weight">Email: </span>
          <span class="blue">1610306103@pku.edu.cn</span>
        </div>
      </div>
      <div class="img">
        <img class="head" :src="img" alt="" />
      </div>
    </div>
    <div class="section">
      <div class="weight">Brief introduction:</div>
      <div class="content">
        Graduated from Peking University and is now a postgraduate student in the Department of Epidemiology and Health Statistics, School of Public Health, Peking University Health Science Center.
      </div>
    </div>
  </div>
</template>
<script>
import img from '@/assets/people/fyq.jpg';
export default {
  data() {
    return {img};
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.page {
  overflow: auto;
  padding: 20px 30px;
  text-align: left;
  font-size: $webpage-base-font-size;
}
.header-section {
  display: flex;
}
.head-context {
  display: flex;
  flex-direction: column;
  gap: 18px
}
.head {
  height: 200px;
  margin-left: 160px;
}
p {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
  margin-bottom: 0;
}
.content {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
}
.weight {
  font-weight: 600
}
.section {
  margin-top: 20px;
  padding-right: 25px;
}
.blue {
  color: $blue-light-1
}
.img {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .header-section {
    display: flex;
    flex-direction: column;
  }
  .head {
    margin-left: 0;
    margin-top: 18px
  }
}
</style>
